import { hourMs, minuteMs } from "verdi-common/timeConstants";

/** e.g. "45m", "1h 05m", "-10m". Gap duration goes negative when runs overlap. */
export function formatDurationLabel(durationMs: number): string {
    const sign = durationMs < 0 ? "-" : "";
    const absMs = Math.abs(durationMs);
    const hours = Math.floor(absMs / hourMs);
    const minutes = Math.floor((absMs % hourMs) / minuteMs);
    if (hours === 0) {
        return `${sign}${minutes}m`;
    }
    return `${sign}${hours}h ${minutes.toString().padStart(2, "0")}m`;
}
